const timeDelta = (date) => {
  let startDate = date;
  let endDate = new Date();
  let seconds = (endDate.getTime() - startDate.getTime()) / 1000;

  let days;
  if (seconds > 86400) {
    days = Math.round(seconds / 86400);
  }

  let months;
  if (days > 30) {
    months = Math.round(days / 30);
    days = Math.round(days % 30);
  }

  let daysString = days > 0 ? (days > 1 ? `${days} days` : `${days} day`) : '';
  let monthsString = months ? (months > 1 ? ` ${months} months` : ` ${months} month`) : '';

  if (daysString || monthsString) {
    return daysString + monthsString;
  } else {
    return 'today';
  }
};

export default timeDelta;
